import classNames from 'classnames';
import { lazy, ReactNode, Suspense, useCallback, useState } from 'react';

import ReactionIcon from '../icons/ReactionIcon';
import BasicButton from './BasicButton';

import styles from '../../styles/buttons/reaction-button.module.css';

const EmojiPicker = lazy(() => import('../partials/EmojiPicker'));

interface ReactionButtonProps {
    className?: string | null;
    onClick?: (() => void | boolean) | null;
    onSelect?: (reaction: string) => void;
    children?: ReactNode | null;
}

function ReactionButton({
    className = null,
    children = null,
    onClick = null,
    onSelect = null,
}: ReactionButtonProps) {
    const [opened, setOpened] = useState(false);
    const onClickToggle = useCallback(() => {
        const shouldOpen = onClick === null || onClick() !== false;
        if (shouldOpen && !opened) {
            setOpened(true);
        } else {
            setOpened(false);
        }
    }, [opened, onClick]);

    const onEmojiSelect = useCallback(
        (emoji) => {
            onSelect?.(emoji.native);
            setOpened(false);
        },
        [onSelect],
    );
    const onClickBackdrop = useCallback(() => {
        if (!opened) {
            return;
        }
        setOpened(false);
    }, [opened]);
    return (
        <>
            <BasicButton
                className={classNames([styles.container, className])}
                onClick={onClickToggle}
            >
                {children || <ReactionIcon className={styles.icon} />}
            </BasicButton>
            {opened ? (
                <Suspense fallback={null}>
                    <div className={styles.modal}>
                        <EmojiPicker
                            className={styles.picker}
                            onEmojiSelect={onEmojiSelect}
                            // onClickOutside={onClickOutside}
                        />
                        <button
                            type="button"
                            className={styles.backdrop}
                            onClick={onClickBackdrop}
                        />
                    </div>
                </Suspense>
            ) : null}
        </>
    );
}

export default ReactionButton;
